// src/services/emailService.js

import { supabase } from "lib/supabase";

export const emailService = {
  // Send welcome email after successful registration
  sendWelcomeEmail: async (email, fullName) => {
    try {
      const { error } = await supabase.functions.invoke("resend-email", {
        body: {
          to: email,
          subject: `Welcome to DecX AI, ${fullName || 'there'}! 🎉`,
          html: 
          `<!DOCTYPE html>
            <html lang="en">
            <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width,initial-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            </head>
            <body style="margin:0;padding:0;background-color:#0D0D0F;font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif;">
            <div style="display:none;max-height:0;overflow:hidden;mso-hide:all;">Your account is live. Here&rsquo;s what&rsquo;s next.&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;</div>
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#0D0D0F;">
            <tr><td align="center" style="padding:40px 16px 60px 16px;">
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="600" style="max-width:600px;width:100%;">
                <!-- LOGO -->
                <tr><td style="padding-bottom:32px;" align="left">
                    <img 
                    src="https://xlowyobpjgwcdaccyqwn.supabase.co/storage/v1/object/public/assets/logo-full-dark.svg"
                    width="160"
                    alt="DecX AI"
                    style="display:block; max-width:160px; height:auto;"
                    />
                </td></tr><tr><td>
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%"
                style="background-color:#111318;border-radius:16px;border:1px solid #1E2330;overflow:hidden;"><tr><td style="background:linear-gradient(90deg,#004AAD 0%,#0082FB 100%);height:3px;font-size:0;line-height:0;">&nbsp;</td></tr><tr><td style="padding:48px 48px 40px 48px;"><table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin-bottom:24px;">
            <tr><td style="background-color:#FFFFFF;border:1px solid Welcome to DecX AI;border-radius:100px;padding:6px 14px;">
                <span style="font-family:'Inter',-apple-system,sans-serif;font-size:12px;font-weight:600;color:linear-gradient(135deg,#004AAD 0%,#0082FB 100%);letter-spacing:0.8px;text-transform:uppercase;">Welcome to DecX AI</span>
            </td></tr>
            </table><h1 style="margin:0 0 12px 0;font-family:'Inter',-apple-system,sans-serif;font-size:30px;font-weight:700;line-height:1.2;color:#FFFFFF;letter-spacing:-0.5px;">Let&rsquo;s get you closing.</h1><p style="margin:0 0 36px 0;font-family:'Inter',-apple-system,sans-serif;font-size:16px;color:#8892A4;line-height:1.65;">You just joined founders and B2B teams who are done guessing what works.</p><table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:14px;background-color:#0D1117;border:1px solid #1A2035;border-radius:10px;">
            <tr><td style="padding:20px 24px;">
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                    <td width="36" style="vertical-align:top;padding-top:2px;">
                    <div style="width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,#004AAD,#0082FB);text-align:center;line-height:28px;">
                        <span style="font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;">1</span>
                    </div>
                    </td>
                    <td style="padding-left:14px;">
                    <p style="margin:0 0 8px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;text-transform:uppercase;letter-spacing:0.5px;">Upload Your Deck</p>
                    <p style="margin:0 0 4px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;color:#8892A4;line-height:1.6;"><span style="color:#0082FB;">&#8594;</span>&nbsp;Get your free DecX Score in 24 hours</p><p style="margin:0 0 4px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;color:#8892A4;line-height:1.6;"><span style="color:#0082FB;">&#8594;</span>&nbsp;Know exactly what&rsquo;s working and what&rsquo;s not</p>
                    </td>
                </tr>
                </table>
            </td></tr>
            </table><table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:14px;background-color:#0D1117;border:1px solid #1A2035;border-radius:10px;">
            <tr><td style="padding:20px 24px;">
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                    <td width="36" style="vertical-align:top;padding-top:2px;">
                    <div style="width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,#004AAD,#0082FB);text-align:center;line-height:28px;">
                        <span style="font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;">2</span>
                    </div>
                    </td>
                    <td style="padding-left:14px;">
                    <p style="margin:0 0 8px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;text-transform:uppercase;letter-spacing:0.5px;">Explore the Platform</p>
                    <p style="margin:0 0 4px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;color:#8892A4;line-height:1.6;"><span style="color:#0082FB;">&#8594;</span>&nbsp;<strong style='color:#C8D0DC;'>Intelligence:</strong> AI + Human reports</p><p style="margin:0 0 4px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;color:#8892A4;line-height:1.6;"><span style="color:#0082FB;">&#8594;</span>&nbsp;<strong style='color:#C8D0DC;'>Agents:</strong> Coming soon &mdash; AI that executes on your report</p><p style="margin:0 0 4px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;color:#8892A4;line-height:1.6;"><span style="color:#0082FB;">&#8594;</span>&nbsp;<strong style='color:#C8D0DC;'>Artefacts:</strong> Pitch canvas, outreach sequences, battle cards</p>
                    </td>
                </tr>
                </table>
            </td></tr>
            </table><table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:14px;background-color:#0D1117;border:1px solid #1A2035;border-radius:10px;">
            <tr><td style="padding:20px 24px;">
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                    <td width="36" style="vertical-align:top;padding-top:2px;">
                    <div style="width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,#004AAD,#0082FB);text-align:center;line-height:28px;">
                        <span style="font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;">3</span>
                    </div>
                    </td>
                    <td style="padding-left:14px;">
                    <p style="margin:0 0 8px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;text-transform:uppercase;letter-spacing:0.5px;">Book a Strategy Call</p>
                    <p style="margin:0 0 4px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;color:#8892A4;line-height:1.6;"><span style="color:#0082FB;">&#8594;</span>&nbsp;30 mins with an operator who&rsquo;s reviewed 1,000+ decks</p>
                    </td>
                </tr>
                </table>
            </td></tr>
            </table><div style="height:8px;"></div><table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:32px;">
            <tr><td style="border-left:3px solid #0082FB;padding:12px 20px;background-color:#0A1628;">
                <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:15px;font-style:italic;color:#C8D0DC;line-height:1.5;">
                Your deck is your messenger.<br>We&rsquo;re here to make sure it lands.
                </p>
            </td></tr>
            </table><table role="presentation" cellspacing="0" cellpadding="0" border="0">
            <tr><td style="border-radius:8px;background:linear-gradient(135deg,#004AAD 0%,#0082FB 100%);">
                <a href="https://app.decx.ai/user-dashboard" style="display:inline-block;padding:15px 36px;font-family:'Inter',-apple-system,sans-serif;font-size:15px;font-weight:600;color:#FFFFFF;text-decoration:none;letter-spacing:0.2px;">Go to Dashboard &rarr;</a>
            </td></tr>
            </table></td></tr></table></td></tr><tr><td style="padding:32px 8px 0 8px;">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr><td style="border-top:1px solid #1E2330;padding-top:28px;">
                <p style="margin:0 0 4px 0;font-family:'Inter',-apple-system,sans-serif;font-size:14px;color:#8892A4;">&mdash; Neeraj<br><strong style='color:#FFFFFF;'>Founder, DecX AI</strong></p>
                <p style="margin:8px 0 0 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:500;color:#0082FB;">decx.ai</p>
                </td></tr>
                <tr><td style="padding-top:20px;"><p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-style:italic;color:#5A6478;">P.S. Reply anytime. I read every email.</p></td></tr>
            </table>
            </td></tr>
                <!-- FOOTER -->
                <tr><td style="padding-top:40px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                    <tr><td align="center" style="padding:20px 24px;background-color:#0A0B0E;border-radius:12px;border:1px solid #1A1D24;">
                        <p style="margin:0 0 6px 0;font-family:'Inter',-apple-system,sans-serif;font-size:12px;color:#3A4152;">
                        You&rsquo;re receiving this from <strong style="color:#4A5568;">DecX AI</strong> &middot;
                        <a href="#" style="color:#3A4152;text-decoration:underline;">Unsubscribe</a> &middot;
                        <a href="#" style="color:#3A4152;text-decoration:underline;">View in browser</a>
                        </p>
                        <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:11px;color:#2A3040;">&copy; 2025 DecX AI. All rights reserved.</p>
                    </td></tr>
                    </table>
                </td></tr>
                </table>
            </td></tr>
            </table>
            </body>
            </html>`
        }
      });

      if (error) {
        console.error("Error sending welcome email:", error);
        return { success: false, error: error.message };
      }

      return { success: true };
    } catch (error) {
      console.error("Welcome email service error:", error);
      return { success: false, error: error.message };
    }
  },
  
  sendDeckSubmittedEmail: async (email, userName, deckTitle, type = 'free') => {
    try {
      const { error } = await supabase.functions.invoke("resend-email", {
        body: {
          to: email,
          subject: `Deck Submitted Successfully`,
          html: `
            <!DOCTYPE html>
                <html lang="en">
                <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width,initial-scale=1.0">
                <meta http-equiv="X-UA-Compatible" content="IE=edge">
                </head>
                <body style="margin:0;padding:0;background-color:#0D0D0F;font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif;">
                <div style="display:none;max-height:0;overflow:hidden;mso-hide:all;">One quick step to get your DecX Score.&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;</div>
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#0D0D0F;">
                <tr><td align="center" style="padding:40px 16px 60px 16px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="600" style="max-width:600px;width:100%;">
                    <!-- LOGO -->
                    <tr><td style="padding-bottom:32px;" align="left">
                    <img 
                    src="https://xlowyobpjgwcdaccyqwn.supabase.co/storage/v1/object/public/assets/logo-full-dark.svg"
                    width="160"
                    alt="DecX AI"
                    style="display:block; max-width:160px; height:auto;"
                    />
                    </td></tr><tr><td>
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%"
                    style="background-color:#111318;border-radius:16px;border:1px solid #1E2330;overflow:hidden;"><tr><td style="background:linear-gradient(90deg,#004AAD 0%,#0082FB 100%);height:3px;font-size:0;line-height:0;">&nbsp;</td></tr><tr><td style="padding:48px 48px 40px 48px;"><table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin-bottom:24px;">
                <tr><td style="background-color:#0082FB;border:1px solid &#9679; Deck Received;border-radius:100px;padding:6px 14px;">
                    <span style="font-family:'Inter',-apple-system,sans-serif;font-size:12px;font-weight:600;color:#0A1628; ;letter-spacing:0.8px;text-transform:uppercase;">Deck Received</span>
                </td></tr>
                </table><h1 style="margin:0 0 12px 0;font-family:'Inter',-apple-system,sans-serif;font-size:30px;font-weight:700;line-height:1.2;color:#FFFFFF;letter-spacing:-0.5px;">Your deck is in.<br>Let&rsquo;s score it.</h1><p style="margin:0 0 36px 0;font-family:'Inter',-apple-system,sans-serif;font-size:16px;color:#8892A4;line-height:1.65;">We&rsquo;re about to analyze it across 5 dimensions. One quick step before we start.</p><table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:0;background-color:#0D1117;border:1px solid #1A2035;border-radius:10px;"><tr><td style="padding:24px 28px;"><p style="margin:0 0 14px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:600;color:#8892A4;letter-spacing:0.8px;text-transform:uppercase;">Analyzing across</p><table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:10px;">
                        <tr>
                            <td width="8" style="vertical-align:middle;"><div style="width:7px;height:7px;border-radius:50%;background-color:#0082FB;"></div></td>
                            <td style="padding-left:12px;font-family:'Inter',-apple-system,sans-serif;font-size:14px;font-weight:500;color:#C8D0DC;">Narrative</td>
                        </tr></table><table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:10px;">
                        <tr>
                            <td width="8" style="vertical-align:middle;"><div style="width:7px;height:7px;border-radius:50%;background-color:#0082FB;"></div></td>
                            <td style="padding-left:12px;font-family:'Inter',-apple-system,sans-serif;font-size:14px;font-weight:500;color:#C8D0DC;">Visual</td>
                        </tr></table><table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:10px;">
                        <tr>
                            <td width="8" style="vertical-align:middle;"><div style="width:7px;height:7px;border-radius:50%;background-color:#0082FB;"></div></td>
                            <td style="padding-left:12px;font-family:'Inter',-apple-system,sans-serif;font-size:14px;font-weight:500;color:#C8D0DC;">Data</td>
                        </tr></table><table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:10px;">
                        <tr>
                            <td width="8" style="vertical-align:middle;"><div style="width:7px;height:7px;border-radius:50%;background-color:#0082FB;"></div></td>
                            <td style="padding-left:12px;font-family:'Inter',-apple-system,sans-serif;font-size:14px;font-weight:500;color:#C8D0DC;">Structure</td>
                        </tr></table><table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:10px;">
                        <tr>
                            <td width="8" style="vertical-align:middle;"><div style="width:7px;height:7px;border-radius:50%;background-color:#0082FB;"></div></td>
                            <td style="padding-left:12px;font-family:'Inter',-apple-system,sans-serif;font-size:14px;font-weight:500;color:#C8D0DC;">Persuasion</td>
                        </tr></table></td></tr></table><div style="height:24px;"></div><p style="margin:0 0 14px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:600;color:#8892A4;letter-spacing:0.8px;text-transform:uppercase;">Why login?</p><table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:32px;"><tr><td style="padding-bottom:10px;font-family:'Inter',-apple-system,sans-serif;font-size:14px;color:#8892A4;line-height:1.5;"><span style="color:#0082FB;font-weight:600;">&#8594;</span>&nbsp; Your DecX Score will be saved to your dashboard</td></tr><tr><td style="padding-bottom:10px;font-family:'Inter',-apple-system,sans-serif;font-size:14px;color:#8892A4;line-height:1.5;"><span style="color:#0082FB;font-weight:600;">&#8594;</span>&nbsp; You can track improvements over time</td></tr><tr><td style="padding-bottom:10px;font-family:'Inter',-apple-system,sans-serif;font-size:14px;color:#8892A4;line-height:1.5;"><span style="color:#0082FB;font-weight:600;">&#8594;</span>&nbsp; You&rsquo;ll unlock access to agents and artefacts</td></tr></table><table role="presentation" cellspacing="0" cellpadding="0" border="0">
                <tr><td style="border-radius:8px;background:linear-gradient(135deg,#004AAD 0%,#0082FB 100%);">
                    <a href="https://app.decx.ai/login-screen" style="display:inline-block;padding:15px 36px;font-family:'Inter',-apple-system,sans-serif;font-size:15px;font-weight:600;color:#FFFFFF;text-decoration:none;letter-spacing:0.2px;">Login to DecX AI &rarr;</a>
                </td></tr>
                </table><p style="margin:20px 0 0 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;color:#4A5568;">Your report will be ready within 24 hours.</p></td></tr></table></td></tr><tr><td style="padding:32px 8px 0 8px;">
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                    <tr><td style="border-top:1px solid #1E2330;padding-top:28px;">
                    <p style="margin:0 0 4px 0;font-family:'Inter',-apple-system,sans-serif;font-size:14px;color:#8892A4;">Talk soon.<br><br>&mdash; Team DecX AI</p>
                    <p style="margin:8px 0 0 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:500;color:#0082FB;">decx.ai</p>
                    </td></tr>
                    <tr><td style="padding-top:20px;"><p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-style:italic;color:#5A6478;">P.S. Questions before we start? Just reply to this email.</p></td></tr>
                </table>
                </td></tr>
                    <!-- FOOTER -->
                    <tr><td style="padding-top:40px;">
                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                        <tr><td align="center" style="padding:20px 24px;background-color:#0A0B0E;border-radius:12px;border:1px solid #1A1D24;">
                            <p style="margin:0 0 6px 0;font-family:'Inter',-apple-system,sans-serif;font-size:12px;color:#3A4152;">
                            You&rsquo;re receiving this from <strong style="color:#4A5568;">DecX AI</strong> &middot;
                            <a href="#" style="color:#3A4152;text-decoration:underline;">Unsubscribe</a> &middot;
                            <a href="#" style="color:#3A4152;text-decoration:underline;">View in browser</a>
                            </p>
                            <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:11px;color:#2A3040;">&copy; 2025 DecX AI. All rights reserved.</p>
                        </td></tr>
                        </table>
                    </td></tr>
                    </table>
                </td></tr>
                </table>
                </body>
                </html>
          `
        }
      });

      if (error) {
        console.error("Error sending welcome email:", error);
        return { success: false, error: error.message };
      }

      return { success: true };
    } catch (error) {
      console.error("Welcome email service error:", error);
      return { success: false, error: error.message };
    }
  },


  sendReportPublishedEmail: async (email, userName, auditType='free', auditId) => {
    let htmlteplate = '';
    if (auditType === 'paid'){
        htmlteplate = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width,initial-scale=1.0">
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <title>DecX AI — Your Full Deck Audit is Ready</title>
        </head>
        <body style="margin:0;padding:0;background-color:#0A0B0D;font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif;">

        <!-- Preview text -->
        <div style="display:none;max-height:0;overflow:hidden;mso-hide:all;">Your paid audit is complete. Slide-by-slide. No holds barred.&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;</div>

        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#0A0B0D;">
        <tr><td align="center" style="padding:40px 16px 60px 16px;">
        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="600" style="max-width:600px;width:100%;">

        <!-- ── LOGO ── -->
        <tr><td style="padding-bottom:36px;" align="left">
            <img 
                    src="https://xlowyobpjgwcdaccyqwn.supabase.co/storage/v1/object/public/assets/logo-full-dark.svg"
                    width="160"
                    alt="DecX AI"
                    style="display:block; max-width:160px; height:auto;"
                    />
        </td></tr>

        <!-- ══════════════════════════════════════════
            SECTION 1 — HERO: Score + Identity
        ══════════════════════════════════════════ -->
        <tr><td>
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#111318;border-radius:16px;border:1px solid #1E2330;overflow:hidden;">

            <!-- Gold premium accent bar -->
            <tr><td style="background:linear-gradient(90deg,#004AAD 0%,#0082FB 50%,#00C6FF 100%);height:3px;font-size:0;line-height:0;">&nbsp;</td></tr>

            <tr><td style="padding:44px 48px 40px 48px;">

                <!-- Paid audit badge -->
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin-bottom:28px;">
                <tr>
                    <td style="background-color:#0A1628;border:1px solid #0082FB;border-radius:100px;padding:7px 16px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                        <tr>
                        <td style="width:8px;height:8px;background:linear-gradient(135deg,#004AAD,#0082FB);border-radius:50%;vertical-align:middle;"></td>
                        <td style="padding-left:8px;font-family:'Inter',-apple-system,sans-serif;font-size:11px;font-weight:700;color:#0082FB;letter-spacing:1.2px;text-transform:uppercase;">Full Deck Audit &mdash; Complete</td>
                        </tr>
                    </table>
                    </td>
                </tr>
                </table>

                <!-- Headline -->
                <h1 style="margin:0 0 10px 0;font-family:'Inter',-apple-system,sans-serif;font-size:32px;font-weight:800;line-height:1.15;color:#FFFFFF;letter-spacing:-0.8px;">
                Your audit is in.
                </h1>


                <!-- Primary CTA — View full report -->
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:8px;">
                <tr>
                    <td style="border-radius:10px;background:linear-gradient(135deg,#004AAD 0%,#0082FB 100%);">
                    <a href="https://app.decx.ai/audit-results-screen" style="display:block;padding:16px 32px;font-family:'Inter',-apple-system,sans-serif;font-size:15px;font-weight:700;color:#FFFFFF;text-decoration:none;text-align:center;letter-spacing:0.2px;">
                        View Your Full Audit Report &rarr;
                    </a>
                    </td>
                </tr>
                </table>
                <p style="margin:0 0 0 0;font-family:'Inter',-apple-system,sans-serif;font-size:12px;color:#3A4152;text-align:center;">Includes slide-by-slide breakdown, annotated feedback &amp; recommendations</p>

            </td></tr>
            </table>
        </td></tr>

        <!-- SPACER -->
        <tr><td style="height:16px;"></td></tr>

        <!-- ══════════════════════════════════════════
            SECTION 2 — WHAT'S IN YOUR AUDIT
        ══════════════════════════════════════════ -->
        <tr><td>
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#111318;border-radius:16px;border:1px solid #1E2330;overflow:hidden;">
            <tr><td style="background:linear-gradient(90deg,#004AAD 0%,#0082FB 100%);height:3px;font-size:0;line-height:0;">&nbsp;</td></tr>
            <tr><td style="padding:36px 48px 36px 48px;">

                <p style="margin:0 0 24px 0;font-family:'Inter',-apple-system,sans-serif;font-size:11px;font-weight:700;color:#4A5568;letter-spacing:1.2px;text-transform:uppercase;">What&rsquo;s inside your full audit</p>

                <!-- 2×2 grid of deliverables -->
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">

                <!-- Row 1 -->
                <tr>
                    <td width="48%" style="vertical-align:top;padding-bottom:14px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#0D1117;border:1px solid #1A2035;border-radius:10px;height:100%;">
                        <tr><td style="padding:20px 20px 20px 20px;">
                        <!-- Icon accent -->
                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin-bottom:14px;">
                            <tr><td style="width:36px;height:36px;background-color:#0A1628;border:1px solid #1A3060;border-radius:8px;text-align:center;vertical-align:middle;">
                            <span style="font-size:16px;line-height:36px;">&#128196;</span>
                            </td></tr>
                        </table>
                        <p style="margin:0 0 6px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;line-height:1.3;">Slide-by-Slide Analysis</p>
                        <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:12px;color:#5A6478;line-height:1.55;">Every slide annotated. What works, what doesn&rsquo;t, and exactly why.</p>
                        </td></tr>
                    </table>
                    </td>
                    <td width="4%">&nbsp;</td>
                    <td width="48%" style="vertical-align:top;padding-bottom:14px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#0D1117;border:1px solid #1A2035;border-radius:10px;height:100%;">
                        <tr><td style="padding:20px 20px 20px 20px;">
                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin-bottom:14px;">
                            <tr><td style="width:36px;height:36px;background-color:#0A1628;border:1px solid #1A3060;border-radius:8px;text-align:center;vertical-align:middle;">
                            <span style="font-size:16px;line-height:36px;">&#128269;</span>
                            </td></tr>
                        </table>
                        <p style="margin:0 0 6px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;line-height:1.3;">Investor Readiness Check</p>
                        <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:12px;color:#5A6478;line-height:1.55;">Assessed against what investors actually look for at first meeting.</p>
                        </td></tr>
                    </table>
                    </td>
                </tr>

                <!-- Row 2 -->
                <tr>
                    <td width="48%" style="vertical-align:top;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#0D1117;border:1px solid #1A2035;border-radius:10px;height:100%;">
                        <tr><td style="padding:20px 20px 20px 20px;">
                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin-bottom:14px;">
                            <tr><td style="width:36px;height:36px;background-color:#0A1628;border:1px solid #1A3060;border-radius:8px;text-align:center;vertical-align:middle;">
                            <span style="font-size:16px;line-height:36px;">&#128221;</span>
                            </td></tr>
                        </table>
                        <p style="margin:0 0 6px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;line-height:1.3;">Rewrite Recommendations</p>
                        <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:12px;color:#5A6478;line-height:1.55;">Specific copy suggestions for weak slides &mdash; ready to use.</p>
                        </td></tr>
                    </table>
                    </td>
                    <td width="4%">&nbsp;</td>
                    <td width="48%" style="vertical-align:top;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#0D1117;border:1px solid #1A2035;border-radius:10px;height:100%;">
                        <tr><td style="padding:20px 20px 20px 20px;">
                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin-bottom:14px;">
                            <tr><td style="width:36px;height:36px;background-color:#0A1628;border:1px solid #1A3060;border-radius:8px;text-align:center;vertical-align:middle;">
                            <span style="font-size:16px;line-height:36px;">&#128247;</span>
                            </td></tr>
                        </table>
                        <p style="margin:0 0 6px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;line-height:1.3;">Visual Design Feedback</p>
                        <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:12px;color:#5A6478;line-height:1.55;">Layout, hierarchy, and presentation quality scored and flagged.</p>
                        </td></tr>
                    </table>
                    </td>
                </tr>

                </table>

            </td></tr>
            </table>
        </td></tr>

        <!-- SPACER -->
        <tr><td style="height:16px;"></td></tr>

        <!-- ══════════════════════════════════════════
            SECTION 4 — ARTEFACTS UNLOCKED
        ══════════════════════════════════════════ -->
        <tr><td>
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#111318;border-radius:16px;border:1px solid #1E2330;overflow:hidden;">
            <tr><td style="background:linear-gradient(90deg,#004AAD 0%,#0082FB 100%);height:3px;font-size:0;line-height:0;">&nbsp;</td></tr>
            <tr><td style="padding:36px 48px 36px 48px;">

                <!-- Section label -->
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin-bottom:20px;">
                <tr>
                    <td style="background-color:#0A1628;border:1px solid #0082FB;border-radius:100px;padding:5px 14px;">
                    <span style="font-family:'Inter',-apple-system,sans-serif;font-size:11px;font-weight:700;color:#0082FB;letter-spacing:1px;text-transform:uppercase;">&#128275; Included with your audit</span>
                    </td>
                </tr>
                </table>

                <h2 style="margin:0 0 8px 0;font-family:'Inter',-apple-system,sans-serif;font-size:20px;font-weight:700;color:#FFFFFF;letter-spacing:-0.3px;">Your artefacts are ready.</h2>
                <p style="margin:0 0 28px 0;font-family:'Inter',-apple-system,sans-serif;font-size:14px;color:#8892A4;line-height:1.55;">
                Built directly from your deck. Not templates &mdash; yours.
                </p>

                <!-- Artefact rows -->
                <!-- Pitch Canvas -->
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:12px;background-color:#0D1117;border:1px solid #1A2035;border-radius:10px;">
                <tr>
                    <td style="padding:16px 20px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                        <tr>
                        <td style="vertical-align:middle;">
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                            <tr>
                                <td style="width:36px;height:36px;background-color:#0A1628;border:1px solid #1A3060;border-radius:8px;text-align:center;vertical-align:middle;">
                                <span style="font-size:16px;line-height:36px;">&#128083;</span>
                                </td>
                                <td style="padding-left:14px;">
                                <p style="margin:0 0 3px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;">Pitch Canvas</p>
                                <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:12px;color:#5A6478;">Your narrative restructured into a clean, investor-ready framework</p>
                                </td>
                            </tr>
                            </table>
                        </td>
                        <td align="right" style="vertical-align:middle;white-space:nowrap;padding-left:16px;">
                            <a href="https://app.decx.ai/artefacts/canvas" style="font-family:'Inter',-apple-system,sans-serif;font-size:12px;font-weight:600;color:#0082FB;text-decoration:none;">Access &rarr;</a>
                        </td>
                        </tr>
                    </table>
                    </td>
                </tr>
                </table>

                <!-- Outreach Sequence -->
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:12px;background-color:#0D1117;border:1px solid #1A2035;border-radius:10px;">
                <tr>
                    <td style="padding:16px 20px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                        <tr>
                        <td style="vertical-align:middle;">
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                            <tr>
                                <td style="width:36px;height:36px;background-color:#0A1628;border:1px solid #1A3060;border-radius:8px;text-align:center;vertical-align:middle;">
                                <span style="font-size:16px;line-height:36px;">&#9993;</span>
                                </td>
                                <td style="padding-left:14px;">
                                <p style="margin:0 0 3px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;">Investor Outreach Sequence</p>
                                <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:12px;color:#5A6478;">3-email cold sequence written around your deck&rsquo;s strongest signals</p>
                                </td>
                            </tr>
                            </table>
                        </td>
                        <td align="right" style="vertical-align:middle;white-space:nowrap;padding-left:16px;">
                            <a href="https://app.decx.ai/artefacts/outreach" style="font-family:'Inter',-apple-system,sans-serif;font-size:12px;font-weight:600;color:#0082FB;text-decoration:none;">Access &rarr;</a>
                        </td>
                        </tr>
                    </table>
                    </td>
                </tr>
                </table>

                <!-- Battle Card -->
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#0D1117;border:1px solid #1A2035;border-radius:10px;">
                <tr>
                    <td style="padding:16px 20px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                        <tr>
                        <td style="vertical-align:middle;">
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                            <tr>
                                <td style="width:36px;height:36px;background-color:#0A1628;border:1px solid #1A3060;border-radius:8px;text-align:center;vertical-align:middle;">
                                <span style="font-size:16px;line-height:36px;">&#9889;</span>
                                </td>
                                <td style="padding-left:14px;">
                                <p style="margin:0 0 3px 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:700;color:#FFFFFF;">Competitive Battle Card</p>
                                <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:12px;color:#5A6478;">Your positioning vs competitors &mdash; mapped, ranked, and ready to defend</p>
                                </td>
                            </tr>
                            </table>
                        </td>
                        <td align="right" style="vertical-align:middle;white-space:nowrap;padding-left:16px;">
                            <a href="https://app.decx.ai/artefacts/battlecard" style="font-family:'Inter',-apple-system,sans-serif;font-size:12px;font-weight:600;color:#0082FB;text-decoration:none;">Access &rarr;</a>
                        </td>
                        </tr>
                    </table>
                    </td>
                </tr>
                </table>

            </td></tr>
            </table>
        </td></tr>

        <!-- SPACER -->
        <tr><td style="height:16px;"></td></tr>

        <!-- ══════════════════════════════════════════
            SECTION 5 — BOOK STRATEGY CALL
        ══════════════════════════════════════════ -->
        <tr><td>
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background:linear-gradient(145deg,#0A1628 0%,#0C1A3A 100%);border-radius:16px;border:1px solid #1A3060;overflow:hidden;">
            <tr><td style="background:linear-gradient(90deg,#004AAD 0%,#0082FB 100%);height:3px;font-size:0;line-height:0;">&nbsp;</td></tr>
            <tr><td style="padding:36px 48px;">

                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                    <td style="vertical-align:middle;">
                    <p style="margin:0 0 6px 0;font-family:'Inter',-apple-system,sans-serif;font-size:11px;font-weight:700;color:#0082FB;letter-spacing:1.2px;text-transform:uppercase;">Go deeper</p>
                    <h2 style="margin:0 0 10px 0;font-family:'Inter',-apple-system,sans-serif;font-size:20px;font-weight:700;color:#FFFFFF;letter-spacing:-0.3px;">Book a 30-min strategy call</h2>
                    <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;color:#8892A4;line-height:1.55;">Walk through your report with an operator who&rsquo;s reviewed 1,000+ decks. Leave with a clear fix-list.</p>
                    </td>
                    <td width="160" align="right" style="vertical-align:middle;padding-left:24px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                        <tr>
                        <td style="border-radius:8px;border:1px solid #0082FB;">
                            <a href="https://app.decx.ai/call" style="display:inline-block;padding:13px 24px;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:600;color:#0082FB;text-decoration:none;white-space:nowrap;">
                            Book Call &rarr;
                            </a>
                        </td>
                        </tr>
                    </table>
                    </td>
                </tr>
                </table>

            </td></tr>
            </table>
        </td></tr>

        <!-- ══════════════════════════════════════════
            SIGN-OFF
        ══════════════════════════════════════════ -->
        <tr><td style="padding:36px 8px 0 8px;">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
            <tr><td style="border-top:1px solid #1A1D24;padding-top:32px;">

                <!-- Tagline -->
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:24px;">
                <tr><td style="border-left:3px solid #0082FB;padding:14px 20px;background-color:#0A1118;border-radius:0 8px 8px 0;">
                    <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:15px;font-style:italic;color:#C8D0DC;line-height:1.55;">
                    Your deck is your messenger.<br>Now you know if it&rsquo;s ready for battle.
                    </p>
                </td></tr>
                </table>

                <p style="margin:0 0 4px 0;font-family:'Inter',-apple-system,sans-serif;font-size:14px;color:#8892A4;">&mdash; Neeraj</p>
                <p style="margin:0 0 8px 0;font-family:'Inter',-apple-system,sans-serif;font-size:14px;font-weight:600;color:#FFFFFF;">Founder, DecX AI</p>
                <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:500;color:#0082FB;">decx.ai</p>
            </td></tr>
            <tr><td style="padding-top:20px;">
                <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-style:italic;color:#5A6478;">P.S. Reply with any questions. I personally review every response.</p>
            </td></tr>
            </table>
        </td></tr>

        <!-- ══════════════════════════════════════════
            FOOTER
        ══════════════════════════════════════════ -->
        <tr><td style="padding-top:40px;">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
            <tr><td align="center" style="padding:20px 24px;background-color:#090A0B;border-radius:12px;border:1px solid #141820;">
                <p style="margin:0 0 6px 0;font-family:'Inter',-apple-system,sans-serif;font-size:12px;color:#3A4152;">
                You&rsquo;re receiving this from <strong style="color:#4A5568;">DecX AI</strong> &middot;
                <a href="#" style="color:#3A4152;text-decoration:underline;">Unsubscribe</a> &middot;
                <a href="#" style="color:#3A4152;text-decoration:underline;">View in browser</a>
                </p>
                <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:11px;color:#2A3040;">&copy; 2025 DecX AI. All rights reserved.</p>
            </td></tr>
            </table>
        </td></tr>

        </table>
        </td></tr>
        </table>
        </body>
        </html>
        `;
    }
    else {
        htmlteplate = `
      <!doctype html>
        <html lang="en">
        <head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width,initial-scale=1.0" />
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        </head>
        <body
            style="
            margin: 0;
            padding: 0;
            background-color: #0d0d0f;
            font-family:
                &quot;Inter&quot;,
                -apple-system,
                BlinkMacSystemFont,
                &quot;Segoe UI&quot;,
                Helvetica,
                Arial,
                sans-serif;
            "
        >
            <div style="display: none; max-height: 0; overflow: hidden; mso-hide: all">
            See exactly what&rsquo;s working and what&rsquo;s
            not.&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;
            </div>
            <table
            role="presentation"
            cellspacing="0"
            cellpadding="0"
            border="0"
            width="100%"
            style="background-color: #0d0d0f"
            >
            <tr>
                <td align="center" style="padding: 40px 16px 60px 16px">
                <table
                    role="presentation"
                    cellspacing="0"
                    cellpadding="0"
                    border="0"
                    width="600"
                    style="max-width: 600px; width: 100%"
                >
                    <!-- LOGO -->
                    <tr>
                    <td style="padding-bottom: 32px" align="left">
                        <img 
                    src="https://xlowyobpjgwcdaccyqwn.supabase.co/storage/v1/object/public/assets/logo-full-dark.svg"
                    width="160"
                    alt="DecX AI"
                    style="display:block; max-width:160px; height:auto;"
                    />
                    </td>
                    </tr>
                    <tr>
                    <td>
                        <table
                        role="presentation"
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        width="100%"
                        style="
                            background-color: #111318;
                            border-radius: 16px;
                            border: 1px solid #1e2330;
                            overflow: hidden;
                        "
                        >
                        <tr>
                            <td
                            style="
                                background: linear-gradient(
                                90deg,
                                #004aad 0%,
                                #0082fb 100%
                                );
                                height: 3px;
                                font-size: 0;
                                line-height: 0;
                            "
                            >
                            &nbsp;
                            </td>
                        </tr>
                        <tr>
                            <td style="padding: 48px 48px 40px 48px">
                            <table
                                role="presentation"
                                cellspacing="0"
                                cellpadding="0"
                                border="0"
                                style="margin-bottom: 24px"
                            >
                                <tr>
                                <td
                                    style="
                                    background-color: #10b981;
                                    border: 1px solid;
                                    border-radius: 100px;
                                    padding: 6px 14px;
                                    "
                                >
                                    <span
                                    style="
                                        font-family:
                                        &quot;Inter&quot;,
                                        -apple-system,
                                        sans-serif;
                                        font-size: 12px;
                                        font-weight: 600;
                                        color: #0a1a10;
                                        letter-spacing: 0.8px;
                                        text-transform: uppercase;
                                    "
                                    >Analysis Complete</span
                                    >
                                </td>
                                </tr>
                            </table>
                            <h1
                                style="
                                margin: 0 0 12px 0;
                                font-family:
                                    &quot;Inter&quot;,
                                    -apple-system,
                                    sans-serif;
                                font-size: 30px;
                                font-weight: 700;
                                line-height: 1.2;
                                color: #ffffff;
                                letter-spacing: -0.5px;
                                "
                            >
                                Your DecX Score is ready.
                            </h1>
                            <p
                                style="
                                margin: 0 0 36px 0;
                                font-family:
                                    &quot;Inter&quot;,
                                    -apple-system,
                                    sans-serif;
                                font-size: 16px;
                                color: #8892a4;
                                line-height: 1.65;
                                "
                            >
                                Here&rsquo;s where you stand. Every dimension. No fluff.
                            </p>
                            <table
                                role="presentation"
                                cellspacing="0"
                                cellpadding="0"
                                border="0"
                            >
                                <tr>
                                <td
                                    style="
                                    border-radius: 8px;
                                    background: linear-gradient(
                                        135deg,
                                        #004aad 0%,
                                        #0082fb 100%
                                    );
                                    "
                                >
                                    <a
                                    href="https://app.decx.ai/audit-results-screen"
                                    style="
                                        display: inline-block;
                                        padding: 15px 36px;
                                        font-family:
                                        &quot;Inter&quot;,
                                        -apple-system,
                                        sans-serif;
                                        font-size: 15px;
                                        font-weight: 600;
                                        color: #ffffff;
                                        text-decoration: none;
                                        letter-spacing: 0.2px;
                                    "
                                    >View Full Report &rarr;</a
                                    >
                                </td>
                                </tr>
                            </table>
                            <table
                                role="presentation"
                                cellspacing="0"
                                cellpadding="0"
                                border="0"
                                width="100%"
                                style="margin: 28px 0"
                            >
                                <tr>
                                <td
                                    style="
                                    height: 1px;
                                    background-color: #1e2330;
                                    font-size: 0;
                                    line-height: 0;
                                    "
                                >
                                    &nbsp;
                                </td>
                                </tr>
                            </table>
                            <p
                                style="
                                margin: 0 0 16px 0;
                                font-family:
                                    &quot;Inter&quot;,
                                    -apple-system,
                                    sans-serif;
                                font-size: 12px;
                                font-weight: 600;
                                color: #4a5568;
                                letter-spacing: 1px;
                                text-transform: uppercase;
                                "
                            >
                                What&rsquo;s Next?
                            </p>
                            <table
                                role="presentation"
                                cellspacing="0"
                                cellpadding="0"
                                border="0"
                                width="100%"
                                style="margin-bottom: 32px"
                            >
                                <tr>
                                <td style="padding-bottom: 12px">
                                    <table
                                    role="presentation"
                                    cellspacing="0"
                                    cellpadding="0"
                                    border="0"
                                    width="100%"
                                    style="
                                        background-color: #0d1117;
                                        border: 1px solid #1a2035;
                                        border-radius: 10px;
                                    "
                                    >
                                    <tr>
                                        <td style="padding: 18px 20px">
                                        <p
                                            style="
                                            margin: 0 0 4px 0;
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 13px;
                                            font-weight: 700;
                                            color: #ffffff;
                                            "
                                        >
                                            &#128269; Go Deeper
                                        </p>
                                        <p
                                            style="
                                            margin: 0 0 10px 0;
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 13px;
                                            color: #8892a4;
                                            line-height: 1.5;
                                            "
                                        >
                                            Slide-by-slide analysis + AI recommendations
                                        </p>
                                        <a
                                            href="https://app.decx.ai/upgrade"
                                            style="
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 12px;
                                            font-weight: 600;
                                            color: #0082fb;
                                            text-decoration: none;
                                            "
                                            >Explore &rarr;</a
                                        >
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                                </tr>
                                <tr>
                                <td style="padding-bottom: 12px">
                                    <table
                                    role="presentation"
                                    cellspacing="0"
                                    cellpadding="0"
                                    border="0"
                                    width="100%"
                                    style="
                                        background-color: #0d1117;
                                        border: 1px solid #1a2035;
                                        border-radius: 10px;
                                    "
                                    >
                                    <tr>
                                        <td style="padding: 18px 20px">
                                        <p
                                            style="
                                            margin: 0 0 4px 0;
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 13px;
                                            font-weight: 700;
                                            color: #ffffff;
                                            "
                                        >
                                            &#128196; Get Artefacts
                                        </p>
                                        <p
                                            style="
                                            margin: 0 0 10px 0;
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 13px;
                                            color: #8892a4;
                                            line-height: 1.5;
                                            "
                                        >
                                            Pitch canvas, outreach sequences, battle
                                            cards &mdash; ready to use
                                        </p>
                                        <a
                                            href="https://app.decx.ai/artefacts"
                                            style="
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 12px;
                                            font-weight: 600;
                                            color: #0082fb;
                                            text-decoration: none;
                                            "
                                            >Get artefacts &rarr;</a
                                        >
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                                </tr>
                                <tr>
                                <td style="padding-bottom: 12px">
                                    <table
                                    role="presentation"
                                    cellspacing="0"
                                    cellpadding="0"
                                    border="0"
                                    width="100%"
                                    style="
                                        background-color: #0d1117;
                                        border: 1px solid #1a2035;
                                        border-radius: 10px;
                                    "
                                    >
                                    <tr>
                                        <td style="padding: 18px 20px">
                                        <p
                                            style="
                                            margin: 0 0 4px 0;
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 13px;
                                            font-weight: 700;
                                            color: #ffffff;
                                            "
                                        >
                                            &#128222; Talk to an Expert
                                        </p>
                                        <p
                                            style="
                                            margin: 0 0 10px 0;
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 13px;
                                            color: #8892a4;
                                            line-height: 1.5;
                                            "
                                        >
                                            30-min strategy call with someone
                                            who&rsquo;s reviewed 1,000+ decks
                                        </p>
                                        <a
                                            href="https://app.decx.ai/call"
                                            style="
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 12px;
                                            font-weight: 600;
                                            color: #0082fb;
                                            text-decoration: none;
                                            "
                                            >Book call &rarr;</a
                                        >
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                                </tr>
                            </table>
                            <table
                                role="presentation"
                                cellspacing="0"
                                cellpadding="0"
                                border="0"
                                width="100%"
                                style="
                                background-color: #090b0f;
                                border: 1px solid #1a2035;
                                border-radius: 12px;
                                "
                            >
                                <tr>
                                <td style="padding: 20px 24px">
                                    <p
                                    style="
                                        margin: 0 0 14px 0;
                                        font-family:
                                        &quot;Inter&quot;,
                                        -apple-system,
                                        sans-serif;
                                        font-size: 11px;
                                        font-weight: 600;
                                        color: #3a4152;
                                        letter-spacing: 1px;
                                        text-transform: uppercase;
                                    "
                                    >
                                    Score Guide
                                    </p>
                                    <table
                                    role="presentation"
                                    cellspacing="0"
                                    cellpadding="0"
                                    border="0"
                                    width="100%"
                                    >
                                    <tr>
                                        <td style="padding-bottom: 10px">
                                        <span
                                            style="
                                            display: inline-block;
                                            background-color: #0a2010;
                                            border: 1px solid #10b981;
                                            border-radius: 4px;
                                            padding: 3px 8px;
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 12px;
                                            font-weight: 600;
                                            color: #10b981;
                                            "
                                            >70+</span
                                        ><span
                                            style="
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 13px;
                                            color: #8892a4;
                                            margin-left: 10px;
                                            "
                                            >Decision-ready. Go get that yes.</span
                                        >
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding-bottom: 10px">
                                        <span
                                            style="
                                            display: inline-block;
                                            background-color: #130a00;
                                            border: 1px solid #d97706;
                                            border-radius: 4px;
                                            padding: 3px 8px;
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 12px;
                                            font-weight: 600;
                                            color: #d97706;
                                            "
                                            >50&ndash;69</span
                                        ><span
                                            style="
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 13px;
                                            color: #8892a4;
                                            margin-left: 10px;
                                            "
                                            >Close, but not closing. Refinement
                                            needed.</span
                                        >
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                        <span
                                            style="
                                            display: inline-block;
                                            background-color: #130000;
                                            border: 1px solid #e05a5a;
                                            border-radius: 4px;
                                            padding: 3px 8px;
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 12px;
                                            font-weight: 600;
                                            color: #e05a5a;
                                            "
                                            >&lt;50</span
                                        ><span
                                            style="
                                            font-family:
                                                &quot;Inter&quot;,
                                                -apple-system,
                                                sans-serif;
                                            font-size: 13px;
                                            color: #8892a4;
                                            margin-left: 10px;
                                            "
                                            >Needs work before it sees daylight.</span
                                        >
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                                </tr>
                            </table>
                            </td>
                        </tr>
                        </table>
                    </td>
                    </tr>
                    <tr>
                    <td style="padding: 32px 8px 0 8px">
                        <table
                        role="presentation"
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        width="100%"
                        >
                        <tr>
                            <td
                            style="border-top: 1px solid #1e2330; padding-top: 28px"
                            >
                            <p
                                style="
                                margin: 0 0 20px 0;
                                font-family:
                                    &quot;Inter&quot;,
                                    -apple-system,
                                    sans-serif;
                                font-size: 15px;
                                font-style: italic;
                                color: #c8d0dc;
                                line-height: 1.5;
                                "
                            >
                                Your deck is your messenger.<br />Now you know if
                                it&rsquo;s ready for battle.
                            </p>
                            <p
                                style="
                                margin: 0 0 4px 0;
                                font-family:
                                    &quot;Inter&quot;,
                                    -apple-system,
                                    sans-serif;
                                font-size: 14px;
                                color: #8892a4;
                                "
                            >
                                &mdash; Neeraj<br /><strong style="color: #ffffff"
                                >Founder, DecX AI</strong
                                >
                            </p>
                            <p
                                style="
                                margin: 8px 0 0 0;
                                font-family:
                                    &quot;Inter&quot;,
                                    -apple-system,
                                    sans-serif;
                                font-size: 13px;
                                font-weight: 500;
                                color: #0082fb;
                                "
                            >
                                decx.ai
                            </p>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding-top: 20px">
                            <p
                                style="
                                margin: 0;
                                font-family:
                                    &quot;Inter&quot;,
                                    -apple-system,
                                    sans-serif;
                                font-size: 13px;
                                font-style: italic;
                                color: #5a6478;
                                "
                            >
                                P.S. Reply with any questions. I personally review every
                                response.
                            </p>
                            </td>
                        </tr>
                        </table>
                    </td>
                    </tr>
                    <!-- FOOTER -->
                    <tr>
                    <td style="padding-top: 40px">
                        <table
                        role="presentation"
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        width="100%"
                        >
                        <tr>
                            <td
                            align="center"
                            style="
                                padding: 20px 24px;
                                background-color: #0a0b0e;
                                border-radius: 12px;
                                border: 1px solid #1a1d24;
                            "
                            >
                            <p
                                style="
                                margin: 0 0 6px 0;
                                font-family:
                                    &quot;Inter&quot;,
                                    -apple-system,
                                    sans-serif;
                                font-size: 12px;
                                color: #3a4152;
                                "
                            >
                                You&rsquo;re receiving this from
                                <strong style="color: #4a5568">DecX AI</strong> &middot;
                                <a
                                href="#"
                                style="color: #3a4152; text-decoration: underline"
                                >Unsubscribe</a
                                >
                                &middot;
                                <a
                                href="#"
                                style="color: #3a4152; text-decoration: underline"
                                >View in browser</a
                                >
                            </p>
                            <p
                                style="
                                margin: 0;
                                font-family:
                                    &quot;Inter&quot;,
                                    -apple-system,
                                    sans-serif;
                                font-size: 11px;
                                color: #2a3040;
                                "
                            >
                                &copy; 2025 DecX AI. All rights reserved.
                            </p>
                            </td>
                        </tr>
                        </table>
                    </td>
                    </tr>
                </table>
                </td>
            </tr>
            </table>
        </body>
        </html>
        `;
    }
    try {
      const { error } = await supabase.functions.invoke("resend-email", {
        body: {
          to: email,
          subject: `Your DecX Score is ready`,
          html: htmlteplate
        }
      });

      if (error) {
        console.error("Error sending welcome email:", error);
        return { success: false, error: error.message };
      }

      return { success: true };
    } catch (error) {
      console.error("Report publish service error:", error);
      return { success: false, error: error.message };
    }
  },

   sendverifyOtpEmail: async (email, otp, expiry = 10) => {
    try {
      const { error } = await supabase.functions.invoke("resend-email", {
        body: {
          to: email,
          subject: `Welcome to DecX AI!`,
          html: 
          `
          <!DOCTYPE html>
            <html lang="en">
            <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width,initial-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            </head>
            <body style="margin:0;padding:0;background-color:#0D0D0F;font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif;">
            <div style="display:none;max-height:0;overflow:hidden;mso-hide:all;">Enter this code to verify your email.&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;</div>
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#0D0D0F;">
            <tr><td align="center" style="padding:40px 16px 60px 16px;">
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="600" style="max-width:600px;width:100%;">
                <!-- LOGO -->
                <tr><td style="padding-bottom:32px;" align="left">
                <img 
                    src="https://xlowyobpjgwcdaccyqwn.supabase.co/storage/v1/object/public/assets/logo-full-dark.svg"
                    width="160"
                    alt="DecX AI"
                    style="display:block; max-width:160px; height:auto;"
                    />
                </td></tr><tr><td>
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%"
                style="background-color:#111318;border-radius:16px;border:1px solid #1E2330;overflow:hidden;"><tr><td style="background:linear-gradient(90deg,#004AAD 0%,#0082FB 100%);height:3px;font-size:0;line-height:0;">&nbsp;</td></tr><tr><td style="padding:48px 48px 40px 48px;"><table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin-bottom:24px;">
            <tr><td style="width:52px;height:52px;background:linear-gradient(135deg,#004AAD,#0082FB);border-radius:12px;text-align:center;vertical-align:middle;">
                <span style="font-size:24px;line-height:52px;">&#128273;</span>
            </td></tr>
            </table><h1 style="margin:0 0 12px 0;font-family:'Inter',-apple-system,sans-serif;font-size:30px;font-weight:700;line-height:1.2;color:#FFFFFF;letter-spacing:-0.5px;">Your verification code</h1><p style="margin:0 0 36px 0;font-family:'Inter',-apple-system,sans-serif;font-size:16px;color:#8892A4;line-height:1.65;">Enter this code to verify your email and complete your signup.</p><table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:28px;">
            <tr><td align="center" style="background-color:#0A1628;border:2px solid #0082FB;border-radius:14px;padding:36px 40px;">
                <p style="margin:0 0 10px 0;font-family:'Inter',-apple-system,sans-serif;font-size:11px;font-weight:600;color:#0082FB;letter-spacing:2px;text-transform:uppercase;">Verification Code</p>
                <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:48px;font-weight:800;color:#FFFFFF;letter-spacing:12px;line-height:1;">${otp}</p>
            </td></tr>
            </table>
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:28px;">
            <tr><td align="center">
                <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;color:#8892A4;">&#9200;&nbsp; This code expires in <strong style="color:#D97706;">${expiry} Minutes</strong></p>
            </td></tr>
            </table>
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#0D1117;border:1px solid #1A2035;border-radius:10px;">
            <tr><td style="padding:14px 20px;">
                <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;color:#5A6478;line-height:1.5;">Didn&rsquo;t request this? Ignore this email &mdash; your account is safe.</p>
            </td></tr>
            </table></td></tr></table></td></tr><tr><td style="padding:32px 8px 0 8px;">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr><td style="border-top:1px solid #1E2330;padding-top:28px;">
                <p style="margin:0 0 4px 0;font-family:'Inter',-apple-system,sans-serif;font-size:14px;color:#8892A4;">&mdash; Team DecX AI</p>
                <p style="margin:8px 0 0 0;font-family:'Inter',-apple-system,sans-serif;font-size:13px;font-weight:500;color:#0082FB;">decx.ai</p>
                </td></tr>
                
            </table>
            </td></tr>
                <!-- FOOTER -->
                <tr><td style="padding-top:40px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                    <tr><td align="center" style="padding:20px 24px;background-color:#0A0B0E;border-radius:12px;border:1px solid #1A1D24;">
                        <p style="margin:0 0 6px 0;font-family:'Inter',-apple-system,sans-serif;font-size:12px;color:#3A4152;">
                        You&rsquo;re receiving this from <strong style="color:#4A5568;">DecX AI</strong> &middot;
                        <a href="#" style="color:#3A4152;text-decoration:underline;">Unsubscribe</a> &middot;
                        <a href="#" style="color:#3A4152;text-decoration:underline;">View in browser</a>
                        </p>
                        <p style="margin:0;font-family:'Inter',-apple-system,sans-serif;font-size:11px;color:#2A3040;">&copy; 2025 DecX AI. All rights reserved.</p>
                    </td></tr>
                    </table>
                </td></tr>
                </table>
            </td></tr>
            </table>
            </body>
            </html>
        `
        }
      });

      if (error) {
        console.error("Error sending welcome email:", error);
        return { success: false, error: error.message };
      }

      return { success: true };
    } catch (error) {
      console.error("Welcome email service error:", error);
      return { success: false, error: error.message };
    }
  },

  sendAdminNotification: async ({ name, email, type='Direct Register' }) => {
    try {
        const adminEmail = "neerajp@decx.ai"; // Change this

        const { error } = await supabase.functions.invoke("resend-email", {
        body: {
            to: adminEmail,
            subject: `🚀 New User Registration - ${name}`,
            html: `
            <!DOCTYPE html>
            <html lang="en">
            <head>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </head>

            <body style="margin:0;padding:0;background-color:#0D0D0F;font-family:Arial,sans-serif;">

                <table width="100%" cellpadding="0" cellspacing="0" style="padding:40px 20px;">
                <tr>
                    <td align="center">

                    <table width="600" cellpadding="0" cellspacing="0"
                        style="background:#111318;border:1px solid #1E2330;border-radius:16px;padding:40px;">

                        <tr>
                        <td align="center" style="padding-bottom:30px;">
                            <img
                            src="https://xlowyobpjgwcdaccyqwn.supabase.co/storage/v1/object/public/assets/logo-full-dark.svg"
                            width="150"
                            alt="DecX AI"
                            />
                        </td>
                        </tr>

                        <tr>
                        <td>
                            <h1 style="margin:0 0 10px;color:#FFFFFF;font-size:28px;">
                            New User Registered
                            </h1>

                            <p style="margin:0 0 30px;color:#8892A4;font-size:15px;line-height:1.6;">
                            A new user has successfully registered on the platform.
                            </p>
                        </td>
                        </tr>

                        <tr>
                        <td>

                            <table width="100%" cellpadding="14" cellspacing="0"
                            style="border-collapse:collapse;background:#0A1628;border-radius:12px;overflow:hidden;">

                            <tr>
                                <td style="color:#8892A4;width:160px;border-bottom:1px solid #1E2330;">
                                Full Name
                                </td>

                                <td style="color:#FFFFFF;border-bottom:1px solid #1E2330;">
                                ${name}
                                </td>
                            </tr>

                            <tr>
                                <td style="color:#8892A4;width:160px;border-bottom:1px solid #1E2330;">
                                Email Address
                                </td>

                                <td style="color:#FFFFFF;border-bottom:1px solid #1E2330;">
                                ${email}
                                </td>
                            </tr>

                            <tr>
                                <td style="color:#8892A4;width:160px;border-bottom:1px solid #1E2330;">
                                Registration Type
                                </td>

                                <td style="color:#FFFFFF;border-bottom:1px solid #1E2330;">
                                ${type}
                                </td>
                            </tr>

                            <tr>
                                <td style="color:#8892A4;width:160px;">
                                Registered At
                                </td>

                                <td style="color:#FFFFFF;">
                                ${new Date().toLocaleString()}
                                </td>
                            </tr>

                            </table>

                        </td>
                        </tr>

                        <tr>
                        <td style="padding-top:40px;">
                            <p style="margin:0;color:#5A6478;font-size:12px;text-align:center;">
                            This is an automated email from DecX AI.
                            </p>
                        </td>
                        </tr>

                    </table>

                    </td>
                </tr>
                </table>

            </body>
            </html>
            `
        }
        });

        if (error) {
        console.error("Admin notification email error:", error);
        return { success: false, error: error.message };
        }

        return { success: true };

    } catch (error) {
        console.error("Admin notification service error:", error);
        return { success: false, error: error.message };
    }
    },

}
